import { DELETE } from "../../APiHelper/API";

export const removeStadium = (team_id, onSuccess, onError) => {
    DELETE(`/api/v1/leagues/team/${team_id}/remove_stadium`, onSuccess, onError)
}